module.exports = __webpack_public_path__ + "img/agognl.f76ebb2c.png";